<template>
  <div class="orderlist bj order-container">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button @click="exportHandle" type="success" icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <div class="auto-table-flex mt20">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        border
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="logisticBusinessName"
          align="center"
          label="集配中心"
        ></el-table-column>
        <el-table-column
          prop="taxpayerTypeName"
          align="center"
          label="纳税人类型"
        ></el-table-column>
        <el-table-column
          prop="supplierName"
          align="center"
          label="供应商名称"
        ></el-table-column>
        <el-table-column
          prop="uscc"
          align="center"
          label="税号"
        ></el-table-column>
        <el-table-column
          prop="supplierMobile"
          align="center"
          label="供应商电话"
        >
          <template slot-scope="scope">
            {{ scope.row.supplierMobile || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="invoiceStartTime"
          align="center"
          label="开通时间"
        ></el-table-column>
        <el-table-column
          prop="invoiceEndTime"
          align="center"
          label="到期时间"
        ></el-table-column>
        <!-- <el-table-column
          prop="uninvoicedAmount"
          align="center"
          label="待开票总金额"
        ></el-table-column> -->
        <el-table-column
          prop="invoicedAmount"
          align="center"
          label="已开票总金额"
        ></el-table-column>
        <!-- <el-table-column
          prop="uninvoicedOrderAmount"
          align="center"
          label="待申请开票金额"
        ></el-table-column> -->
        <el-table-column prop="invoiceStatusName" align="center" label="状态">
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleView(scope.row)"
              v-if="scope.row.invoiceStatus == 2"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.invoiceStatus == 2"
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleTerminate(scope.row)"
              >终止开票</el-button
            >
            <el-button
              v-if="scope.row.invoiceStatus != 2"
              type="text"
              size="small"
              style="color: #67c23a"
              @click="handleOpen(scope.row)"
              >开通</el-button
            >
            <!-- 驳回 -->
             <el-button
              v-if="scope.row.invoiceStatus != 2"
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleReject(scope.row)"
              >驳回</el-button
              >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from1.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 开通/查看对话框 -->
    <el-dialog
      :title="
        isView
          ? `${dialogForm.supplierName}的开票信息`
          : `请输入${dialogForm.supplierName}的开通的账户和密钥`
      "
      :visible.sync="openDialog"
      width="400px"
      class="center-dialog"
      top="0"
    >
      <el-form :model="dialogForm" label-width="80px" autocomplete="off">
        <el-form-item label="税号：">
          <span>{{ dialogForm.uscc }}</span>
        </el-form-item>
        <el-form-item label="账户：">
          <el-input
            v-model="dialogForm.invoice_app_key"
            placeholder="请输入账户"
            autocomplete="off"
            :disabled="isView"
          ></el-input>
        </el-form-item>
        <el-form-item label="密钥：">
          <el-input
            v-model="dialogForm.invoice_app_secret"
            placeholder="请输入密钥"
            type="password"
            autocomplete="new-password"
            :disabled="isView"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="openDialog = false">{{
          isView ? "关闭" : "取消"
        }}</el-button>
        <el-button v-if="!isView" type="primary" @click="submitOpen"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "SupplierInvoice",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "供应商名称",
          clearable: true,
          model: "search_supplier_name",
          placeholder: "请输入供应商名称",
        },
        {
          type: "input",
          name: "供应商电话",
          clearable: true,
          model: "search_supplier_mobile",
          placeholder: "请输入供应商电话",
        },
        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "search_supplier_invoice_auth",
          placeholder: "请选择状态",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "0" },
            { label: "可开票", value: "1" },
            { label: "不可开票", value: "2" },
          ],
        },
        {
          type: "select",
          name: "供应商类型",
          clearable: true,
          model: "search_taxpayer_type",
          placeholder: "请选择供应商类型",
          label: "label",
          value: "value",
          selectoption: [
            { label: "一般纳税人", value: "1" },
            { label: "小规模纳税人", value: "2" },
            { label: "个体户", value: "3" },
          ],
        },
        {
          type: "daterange",
          name: "开通时间",
          clearable: true,
          model: "open_time_range",
          startmodel: "search_invoice_start_time",
          endmodel: "search_invoice_end_time",
          startplaceholder: "开始日期",
          endplaceholder: "结束日期",
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "search_logistic_business_id",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "logisticsList",
        },
      ],
      loading: false,
      from1: {
        search_supplier_name: "",
        search_supplier_mobile: "",
        search_supplier_invoice_auth: "0",
        search_taxpayer_type: "",
        search_invoice_start_time: "",
        search_invoice_end_time: "",
        open_time_range: [],
        search_logistic_business_id: "",
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      openDialog: false,
      isView: false,
      dialogForm: {
        supplier_id: "",
        supplierName: "",
        uscc: "",
        invoice_app_key: "",
        invoice_app_secret: "",
      },
    };
  },
  created() {
    this.getLogisticsList();
    this.getList();
  },
  methods: {
    getLogisticsList() {
      this.$api.general.businessList().then((res) => {
        const logisticsItem = this.Filtersearchlist.find(
          (item) => item.selectoptionname === "logisticsList"
        );
        if (logisticsItem) {
          logisticsItem.selectoption = res.data;
        }
      });
    },
    getList() {
      this.loading = true;
      this.$api.invoice
        .supplierInvoiceList(this.from1)
        .then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search(e) {
      this.from1 = e;
      this.from1.page = 1;
      this.getList();
    },
    Refresh() {
      this.from1 = {
        search_supplier_name: "",
        search_supplier_mobile: "",
        search_supplier_invoice_auth: "0",
        search_taxpayer_type: "",
        search_invoice_start_time: "",
        search_invoice_end_time: "",
        open_time_range: [],
        search_logistic_business_id: "",
        page: 1,
        pageSize: 10,
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.from1.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.from1.page = val;
      this.getList();
    },
    handleView(row) {
      this.$router.push({
        path: "/SupplierInvoiceDetail",
        query: {
          uscc: row.uscc, // 税号
          invoiceStartTime: row.invoiceStartTime, // 开通时间
        },
      });
    },
    handleTerminate(row) {
      this.$confirm("确定终止该供应商开票吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.invoice
          .terminateInvoice({ supplier_id: row.supplierId })
          .then(() => {
            this.$message.success("终止成功");
            this.getList();
          });
      });
    },
    handleOpen(row) {
      this.isView = false;
      this.dialogForm = {
        supplier_id: row.supplierId,
        supplierName: row.supplierName,
        uscc: row.uscc,
        invoice_app_key: "",
        invoice_app_secret: "",
      };
      this.openDialog = true;
    },
    // 弹窗确认驳回
    handleReject(row) {
      this.$confirm("是否确认驳回？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.invoice.rejectInvoice({ supplier_id: row.supplierId }).then((res) => {
          this.$message.success(res.msg || "驳回成功");
          this.getList();
        });
      });
    },
    submitOpen() {
      if (
        !this.dialogForm.invoice_app_key ||
        !this.dialogForm.invoice_app_secret
      ) {
        return this.$message.error("请输入账户和密钥");
      }
      this.$api.invoice.openInvoice(this.dialogForm).then(() => {
        this.$message.success("开通成功");
        this.openDialog = false;
        this.getList();
      });
    },
    exportHandle() {
      this.$confirm("确定导出供应商开票管理列表吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const query = {
          ...this.from1,
          token: sessionStorage.getItem("token"),
        };
        this.$api.invoice.supplierInvoiceExport(query).then(() => {
          this.$message.success("导出任务已提交，请前往下载中心查看");
          this.goExportCenter();
        });
      });
    },
    goExportCenter() {
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .center-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .el-dialog {
      margin: 0 !important;
    }
  }
}
</style>
